import { ITextFieldProps, TextField as BaseTextField } from "@fluentui/react";

export type TextFieldProps = ITextFieldProps;
export const TextField = BaseTextField;
